<template>
    <Card>
      <AjaxForm route="admin/ProductCategory/Add">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput label="عنوان" placeholder="عنوان..." name="title" type="text"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput label="عنوان انگلیسی" placeholder="عنوان انگلیسی..." name="en_title" type="text"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput label="آیکن" placeholder="آیکن..." name="icon" type="text"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
                <CustomInput type="select" name="parent_id" reduce_select="_id" select-label="title"
                             v-model="category" :fetch-options="getProductCategoryForSelect" label="سردسته"
                             :select-options="select_cat_options" placeholder="سردسته را انتخاب کنید"
                ></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput v-if="choose_guild" placeholder="صنف کاری را انتخاب کنید" label="صنف کاری" name="guild_id" select-label="title" :select-options="select_guild_option"
                         :fetch-options="getGuildsForSelect"
                         v-model="guild"
                         reduce_select="_id" type="select"></CustomInput>
            <div class="p-1" v-if="!choose_guild">صنف کاری : {{category.guild_id.title}}</div>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput name="description" label="توضیحات" placeholder="توضیحات..." type="textarea"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4 d-flex">
            <label class="mr-3">تصویر</label>
            <ImagePicker name="pic_id"></ImagePicker>
          </div>
        </div>
        <h5>ویژگی های محصولات دسته بندی</h5>
        <button type="button" @click="addNewAttr" class="btn btn-info mb-2">افزودن ویژگی جدید</button>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th style="width: 20%">ویژگی</th>
              <th style="width: 70%">مقادیر پیش فرض</th>
              <th style="width: 10%">حذف</th>
            </tr>
            </thead>
            <tbody>
            <PCatAttrItem @delete="deleteItem(index)" v-for="(item,index) in attributes" :key="item"  :item="item"></PCatAttrItem>
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="col-10 col-sm-10 col-md-5 mx-auto">
            <button class="btn btn-info btn-block">ثبت اطلاعات دسته بندی</button>
          </div>
        </div>
      </AjaxForm>
    </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import MasterLayout from "@/components/MasterLayout";
import AjaxForm from "@/components/forms/AjaxForm";
import CustomInput from "@/components/CustomInput";
import {ProductApi} from "@/api/ProductApi";
import PCatAttrItem from "@/components/PCatAttrItem";
import vSelect from 'vue-select'
import ImagePicker from "@/components/ImagePicker";
import {mapActions} from "vuex";

export default {
  name: "AddProductCategory",
  components: {ImagePicker, PCatAttrItem, CustomInput, AjaxForm, MasterLayout, Card,vSelect},
  data(){
    return{
      select_cat_options : [],
      select_guild_option : [],
      attributes : [],
      xx:null,
      category : null,
      choose_guild : true,
      guild : null,
    }
  },
  async mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('افزودن دسته بندی محصول');
    this.setShowHead(true);
  },
  methods : {
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
    async getProductCategoryForSelect(search, loading)
    {
      loading(true);
      if (search.length > 1)
      {
        const data = await ProductApi.getProductCategoryForSelectAjax(search);
        if (data.ok)
        {
          this.select_cat_options = data.cats;
        }
        else
            this.select_cat_options = [];
      }
      loading(false);
    },
    async getGuildsForSelect(search,loading)
    {
      loading(true);
      if (search.length > 1)
      {
        const data = await ProductApi.getGuildForSelectAjax(search);
        if (data.ok)
        {
          this.select_guild_option = data.guilds;
        }
        else
          this.select_guild_option = [];
      }
      loading(false);
    },
    addNewAttr()
    {
      const attributes = (this.attributes?this.attributes:[]);
      attributes.push({attr_id : null,attr_item_ids : [],required : null,options : []});
      this.attributes = attributes;
    },
    deleteItem(index)
    {
      this.attributes.splice(index,1);
    }
  },
  watch:{
    category:{
      handler(category)
      {
        if (category)
          this.choose_guild = category._id === '0';
        else
          this.choose_guild = true;
      }
    }
  },
}
</script>

<style scoped>

</style>